import React from 'react';

import styles from './executiveStyles';

import EditableImage from 'buyside/components/presentation/EditableImage/editableImage';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { truncateText } from 'buyside/util/textHelpers';
import { formatLineBreaks } from 'buyside/util/userInputHelper';

const MAX_BIO_LENGTH = 500;

class Executive extends React.Component {
  constructor() {
    super();
    this.state = { truncated: true };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ truncated: !this.state.truncated });
  }

  render() {
    const { executive } = this.props;
    const { name, photoProfileUrl } = executive;
    let bio = executive.bio || '';
    bio = bio.trim();
    let readMoreButton = null;
    if (bio.length > MAX_BIO_LENGTH) {
      let showText;
      if (this.state.truncated) {
        bio = truncateText(executive.bio, MAX_BIO_LENGTH);
        showText = 'Read more';
      } else {
        showText = 'Read less';
      }
      readMoreButton = (
        <Button
          type={BUTTON_TYPES.LINK}
          text={showText}
          onClick={this.handleClick}
          inherit
          className={styles.executiveReadMoreButton}
        />
      );
    }
    return (
      <li className={styles.executive}>
        <div className={styles.executivePhoto}>
          <EditableImage isEditable={false} croppedImage={photoProfileUrl} isCircular />
        </div>
        <div>
          <h4 className={styles.executiveBioHeading}>{name}</h4>
          <span>
            {formatLineBreaks(bio)} {readMoreButton}
          </span>
        </div>
      </li>
    );
  }
}

export default Executive;
